var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-col',{attrs:{"slot":"content","span":24},slot:"content"},_vm._l((_vm.list),function(item,index){return _c('a-row',{key:index},[(item)?_c('ads-item',{attrs:{"item":item,"index":index},on:{"qrcode":_vm.qrcode}}):_vm._e()],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }